var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "available-labour-sundry quote-builder-add-items" },
    [
      _c("div", { staticClass: "fixed-grid" }, [
        _c("div", { staticClass: "grid" }, [
          _c("div", { staticClass: "cell" }, [
            _c("div", { staticClass: "field has-addons" }, [
              _c(
                "div",
                { staticClass: "control has-icons-left has-icons-right" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchValue,
                        expression: "searchValue",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Start typing to filter",
                    },
                    domProps: { value: _vm.searchValue },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.searchValue = $event.target.value
                        },
                        _vm.search,
                      ],
                    },
                  }),
                  _vm._m(0),
                ]
              ),
              _c("div", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary is-outlined tooltip",
                    attrs: { "data-tooltip": "Reset search" },
                    on: {
                      click: function ($event) {
                        return _vm.reset()
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "cell" }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-container-avaialble-butterfly-items pr-1" },
        [
          _c(
            "div",
            {
              staticClass: "fixed-grid has-12-cols mb-2",
              class: `quote-item-heading-${_vm.$theme.name}`,
              staticStyle: {
                position: "sticky",
                top: "0px",
                "z-index": "10",
                "border-bottom": "1px solid grey",
              },
            },
            [_vm._m(2)]
          ),
          _c(
            "div",
            { staticClass: "fixed-grid has-12-cols" },
            _vm._l(_vm.availableItems, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "grid my-2 p-1",
                  class: {
                    ["quote-builder-item-" + _vm.$theme.name]: index % 2 !== 0,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: item.itemName, placement: "top" },
                          expression:
                            "{ content: item.itemName, placement: 'top' }",
                        },
                      ],
                      staticClass: "cell is-col-span-8 has-overflow-ellipsis",
                      staticStyle: {
                        "white-space": "nowrap",
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                      },
                      on: {
                        dblclick: function ($event) {
                          return _vm.addNewItems(item, index)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.itemName) + " ")]
                  ),
                  _c("div", { staticClass: "cell is-col-span-4" }, [
                    _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                      _c("div", { staticClass: "grid" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cell is-col-span-6 has-text-center",
                            on: {
                              click: function ($event) {
                                return _vm.addSingleNewItem(
                                  item,
                                  _vm.itemCategoryTypes.RR,
                                  true
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "butterfly-item-values is-flex is-justify-content-center",
                                class: {
                                  " has-text-weight-bold is-selected":
                                    _vm.findItem(
                                      item,
                                      _vm.itemCategoryTypes.RR
                                    ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        item.maximumTimeAllowance,
                                        _vm.$userInfo.locale,
                                        0
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "cell is-col-span-6 has-text-center",
                            on: {
                              click: function ($event) {
                                return _vm.addSingleNewItem(
                                  item,
                                  _vm.itemCategoryTypes.PAINT,
                                  true
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "butterfly-item-values is-flex is-justify-content-center",
                                class: {
                                  " has-text-weight-bold is-selected":
                                    _vm.findItem(
                                      item,
                                      _vm.itemCategoryTypes.PAINT
                                    ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        _vm.getPaintRateVehicleLayerGroup(item),
                                        _vm.$userInfo.locale,
                                        0
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm.availableItems.length === 0 && !_vm.isLoadingData
            ? _c("div", { staticClass: "grid-empty" }, [_vm._m(3)])
            : _vm._e(),
          _vm.isLoadingData
            ? _c("div", { staticClass: "grid-empty" }, [_vm._m(4)])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "grid" }, [
      _c("div", { staticClass: "cell is-col-span-8" }, [_vm._v("Item Name")]),
      _c("div", { staticClass: "cell is-col-span-4" }, [
        _c("div", { staticClass: "fixed-grid has-12-cols" }, [
          _c("div", { staticClass: "grid" }, [
            _c("div", { staticClass: "cell is-col-span-6 has-text-center" }, [
              _vm._v("R&R (H)s"),
            ]),
            _c("div", { staticClass: "cell is-col-span-6 has-text-center" }, [
              _vm._v("Paint (H)s"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
        ]),
        _c("p", [_vm._v("Nothing")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", {
            staticClass: "mdi mdi-50px mdi-48 px mdi-loading mdi-spin",
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }